@if ({ underMaintenance: underMaintenance$ | async }; as source) {
	<p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', top: '0', left: '0' } }" />

	<!-- Custom toast to display update notice-->
	<p-toast key="reload" [breakpoints]="{ '920px': { width: '100%', right: '0', top: '0', left: '0' } }">
		<ng-template pTemplate="message" let-message>
			<div class="update-toast-content">
				<div class="toast-header">Update available</div>
				<div>A new version of the application is available. Please reload to get the new version.</div>
				<p-button label="Reload" (onClick)="updateService.reloadApplication()" />
			</div>
		</ng-template>
	</p-toast>

	<!-- Custom toast with providable message and button.-->
	<p-toast key="custom" [breakpoints]="{ '920px': { width: '100%', right: '0', top: '0', left: '0' } }">
		<ng-template let-message pTemplate="message">
			<div class="update-toast-content">
				<div class="toast-header">{{ message.summary }}</div>
				<div>{{ message.detail }}</div>

				@if (message.data) {
					<p-button [label]="message.data.label" (onClick)="message.data.function()" />
				}
			</div>
		</ng-template>
	</p-toast>

	<div class="layout">
		<div class="header-container">
			<app-header />
		</div>
		@if (source.underMaintenance === true) {
			<app-under-maintenance />
		} @else if (source.underMaintenance === false) {
			<p-confirmDialog />
			<main class="main">
				@if (!!(authService.userData$ | async)?.sessionID) {
					<router-outlet />
				} @else {
					<div class="sign-in-container">
						<p-card header="Sign in">
							<div class="sign-in-content">
								@if (!isProcessingAuthentication()) {
									<div>Welcome to Chimera. Please sign in to access the application.</div>
									<p-button icon="pi pi-sign-in" label="Sign in" (onClick)="authService.login()" />
								} @else {
									<p-progressSpinner />
								}
							</div>
						</p-card>
					</div>
				}
			</main>
			<div class="footer">
				<a class="footer-link" [href]="supportUrl" target="_blank">Support</a>
				<p-divider layout="vertical" />
				<a class="footer-link" [href]="wikiUrl" target="_blank">Wiki</a>
			</div>
		}
	</div>
}
